// extracted by mini-css-extract-plugin
export default {"container":"MagazineListPage_container__edCXP","body":"MagazineListPage_body__dmLq7"};